export default __webpack_public_path__ + "static/author-default-69e081e7f0ddd23ffb7faffbca84cc51.png";